import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-style-four',
  templateUrl: './progress-style-four.component.html',
  styleUrls: ['./progress-style-four.component.scss']
})
export class ProgressStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
